var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx-login"},[_c('div',{staticClass:"login-wx-login"},[_c('div',{attrs:{"id":"wxlogin"}})])])
}]

export { render, staticRenderFns }